///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

// service
import { GtthStaticContentService } from '../../help/release-notes/service/static-content.service';

// models
import { StaticContentDTO } from '../../generated/shared-types.model';
import { ContextSensitiveHelp } from '../../help/release-notes/service/user-manual.types';

// rxjs
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { _get, _set } from '../utils';

@Injectable({
    providedIn: 'root'
})
export class GtthCtxSensitiveHelpService {
    private storage: StaticContentDTO;

    constructor(private readonly staticContentService: GtthStaticContentService) {}

    public loadConfig(): void {
        this.staticContentService.getContent(ContextSensitiveHelp.TOOLTIPS).subscribe((storage: StaticContentDTO) => {
            this.storage = storage;
            if (!this.storage.content) {
                this.storage.content = {};
            }
        });
    }

    getText(path: string): string {
        let text: string;
        if (this.storage) {
            text = _get(this.storage.content, path);
        }
        return text;
    }

    setText(path: string, text: string): Observable<string> {
        _set(this.storage.content, path, text.trim());
        return this.staticContentService.save(this.storage).pipe(
            tap((storage: StaticContentDTO) => (this.storage = storage)),
            map((storage: StaticContentDTO) => storage.content),
            map((content: any) => _get(content, path))
        );
    }
}
